module.exports = __webpack_public_path__ + "static/img/31991e3c.png";